<template>
  <div class="outbound-details-page">
    <div class="progress">
      <div class="track-title">
        <div class="track-info">
          <div>{{ selectItem.platformTrackName }}</div>
          <div>{{ selectItem.platformTrackNum }}</div>
        </div>
        <div class="track-btn" @click="copyBtn(selectItem.platformTrackNum)">复制</div>
      </div>
      <div class="step-box">
        <template v-if="expressDeliveryInfo.length > 0">
          <div class="step-title">运输中</div>
          <div class="step-info">{{ expressDeliveryInfo[0].context }}</div>
        </template>
        <template v-else>
          <div class="step-title">暂无揽件信息</div>
          <div class="step-info">该快递暂无揽件信息</div>
        </template>
      </div>
      <div class="step-btn" @click="onclickViewAll">查看全部</div>
    </div>
    <div class="device-box">
        <div class="device-box-title">返厂设备</div>
        <div v-for="(item, index) in selectItem.deviceCountList" :key="index" class="device-item">
            <div class="left">
                <div class="icon">
                    <img :src="item.url" alt="" />
                </div>
                <div class="name">{{ item.deviceTypeName }}</div>
            </div>
            <div class="right">{{ item.count }}台</div>
        </div>
    </div>
    <div v-if="selectItem.factoryConfirmedName" class="details-item">
      <div class="title">签收人</div>
      <div class="content">{{ selectItem.factoryConfirmedName }}</div>
    </div>
    <div v-if="selectItem.factoryConfirmedTime" class="details-item">
      <div class="title">确认时间</div>
      <div class="content">{{ selectItem.factoryConfirmedTime | formateTime }}</div>
    </div>
    <div class="details-item">
      <div class="title">出库库房</div>
      <div class="content">{{ selectItem.warehouseName }}</div>
    </div>
    <div class="details-item">
      <div class="title">登记时间</div>
      <div class="content">{{ selectItem.time | formateTime }}</div>
    </div>
    <div v-if="selectItem.factoryConfirmedStatus == 0" class="footer-btn" @click="signForBtn">
      确认签收
    </div>
  </div>
</template>

<script>
import { formateTime } from '@/utils/time'
import { Toast, Dialog } from "vant";
export default {
    name: 'OutBoundInfo',
    filters: {
        formateTime
    },
    data() {
        return {
            selectItem: {},
            expressDeliveryInfo: []
        }
    },
    created() {
        this.initInfo();
    },
    methods: {
        initInfo() {
            // 初始化出库详情信息
            const vm = this;
            const { ossHostPond } = this.$config.base;
            let item = {};
            if (this.$route.params.item) {
                item = this.$route.params.item;
                item.deviceCountList.forEach(item => {
                    item.url = `${ossHostPond}img/${this.$strTool.getDeviceType(item.deviceType).url}`;
                });
                vm.$localStorage.setItem('outBoundItem', item);
            } else {
                item = vm.$localStorage.getItem('outBoundItem');
            }
            this.selectItem = item;
            vm.getExpressDeliveryInfo();
        },

        // 获取物流信息
        getExpressDeliveryInfo() {
            const vm = this;
            vm.$http({
                type: "get",
                url: `${vm.$config.base.MP_WECHAT_BASE_URL}erpFactory/trackingInfo`,
                params: {
                    password: vm.$config.base.wechatPassword,
                    wayBillNumber: vm.selectItem.platformTrackNum,
                    companyCode: vm.selectItem.platformTrackCompanyCode,
                    phone: vm.selectItem.platformTrackSendPhone,
                }
            }).then((res) => {
                vm.expressDeliveryInfo = res.data.data || [];
            })
        },
        copyBtn(text) {
            // 创建临时textarea元素
            const textarea = document.createElement('textarea')
            textarea.value = text
            textarea.style.position = 'fixed'
            document.body.appendChild(textarea)
            textarea.select()
            
            try {
                const successful = document.execCommand('copy')
                Toast.success({
                    message: successful ? '复制成功' : '复制失败',
                    forbidClick: false,
                    overlay: true,
                    duration: 2000,
                });
            } catch (err) {
                this.$toast('复制失败')
                Toast.success({
                    message: '复制失败',
                    forbidClick: false,
                    overlay: true,
                    duration: 2000,
                });
            }
            
            document.body.removeChild(textarea)
        },
        onclickViewAll() {
            this.$router.push({
                name: "SalesRecords",
                params: {
                    expressDeliveryInfo: this.expressDeliveryInfo
                }
            })
        },
        // 确认签收按钮
        signForBtn() {
            const vm = this;
            Dialog.confirm({
                    title: "是否确认签收",
                    message: "请确认收到的设备类型和数量无误",
                }).then(() => {
                    vm.$http({
                        type: "put",
                        url: `${vm.$config.base.MP_WECHAT_BASE_URL}erpFactory/getOutbound`,
                        params: {
                            password: vm.$config.base.wechatPassword,
                            outboundId: vm.selectItem.id,
                            factoryType: vm.selectItem.factoryType,
                            factoryConfirmedName: vm.$localStorage.getItem('userName'),
                        }
                    }).then((res) => {
                        if (res.code == 1) {
                            Toast.success({
                                message: '签收成功',
                                forbidClick: false,
                                overlay: true,
                                duration: 2000,
                            });
                            setTimeout(() => {
                                this.$router.back()
                            }, 2000);
                        } else {
                            Toast.fail({
                                message: res.msg || '签收失败',
                                forbidClick: false,
                                overlay: true,
                                duration: 2000,
                            });
                        }
                    })
                }).catch(() => {
                    // 用户点击取消
                });
        }
    }
}
</script>

<style lang="less" scoped>
.outbound-details-page {
  background: #f6f9fa;
  height: 100%;
  padding: 0.1rem;
  
  .progress {
    height: 2.25rem;
    width: 100%;
    border-radius: 0.05rem;
    background: #ffffff;
    padding: 0.1rem;
    margin-bottom: 0.15rem;
    
    .track-title {
      font-size: 0.16rem;
      display: flex;
      justify-content: space-between;
      color: #333333;
      
      .track-info {
        display: flex;
        
        div {
          margin-right: 0.1rem;
        }
      }
      
      .track-btn {
        color: #209a56;
        cursor: pointer;
      }
    }
    
    .step-box {
      margin-top: 0.15rem;
      padding: 0.05rem 0.15rem 0.05rem 0.25rem;
      
      .step-title {
        font-size: 0.16rem;
        color: #209a56;
        font-weight: bold;
        position: relative;
        
        &::after {
          content: ' ';
          position: absolute;
          height: 0.15rem;
          width: 0.15rem;
          border-radius: 50%;
          background: #209a56;
          left: -0.2rem;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      
      .step-info {
        font-size: 0.14rem;
        color: #555555;
        margin-top: 0.03rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    
    .step-btn {
      width: 1.3rem;
      height: 0.4rem;
      background: #209a56;
      border-radius: 0.2rem;
      margin: 0.3rem auto 0 auto;
      text-align: center;
      line-height: 0.4rem;
      font-size: 0.18rem;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .device-box {
    width: 100%;
    border-radius: 0.05rem;
    background: #ffffff;
    margin-bottom: 0.15rem;
    padding: 0.15rem;
    font-size: 0.18rem;
    .device-box-title {
        color: #555;
    }
    .device-item {
        height: 0.5rem;
        display: flex;
        justify-content: space-between;
        color: #333333;
        margin-top: 0.15rem;
        .left {
            display: flex;
            align-items: center;
            .icon {
                width: 0.5rem;
                height: 0.5rem;
                overflow: hidden;
                margin-right: 0.1rem;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .right {
            display: flex;
            align-items: center;
        }
    }
  }
  
  .details-item {
    height: 0.7rem;
    width: 100%;
    border-radius: 0.05rem;
    background: #ffffff;
    margin-bottom: 0.15rem;
    display: flex;
    justify-content: space-between;
    padding: 0 0.15rem;
    line-height: 0.7rem;
    font-size: 0.18rem;
    color: #333333;
    
    .title {
      font-weight: bold;
    }
    
    .content {
      color: #555555;
    }
  }
  .footer-btn {
    height: 0.5rem;
    width: 1.7rem;
    border-radius: 0.3rem;
    background: #209a56;
    text-align: center;
    line-height: 0.5rem;
    color: #ffffff;
    font-size: 0.18rem;
    margin: 0.15rem auto;
  }
}
</style>